import { Text } from "@asayinc/component-library";
import { Box } from "@mui/material";

import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { ScrollContainer } from "src/components/containers/ScrollContainer";
import { DashboardProxyEventsSummary } from "./components/DashboardProxyEventsSummary";
import { DashboardReportsSummary } from "./components/DashboardReportsSummary";
import { DashboardNoboEventsSummary } from "./components/DashboardNoboEventsSummary";
import { DashboardClaimsAdminSummary } from "./components/DashboardClaimsAdminSummary";
import { RecentActivitySection } from "./components/RecentActivitySection";
import { UpcomingDeadlinesSection } from "./components/UpcomingDeadlinesSection";
import { useCurrentUserQuery } from "src/store/user";

export function Dashboard() {
  const { data: currentUser } = useCurrentUserQuery();

  const hasSolicitors = (currentUser?.solicitors?.length ?? 0) > 0;
  const hasTabulators = (currentUser?.tabulators?.length ?? 0) > 0;
  const hasClaimsAdministrators =
    (currentUser?.claimsAdministrators?.length ?? 0) > 0;

  const showProxyEvents = hasSolicitors || hasTabulators;
  const showReports = hasSolicitors;
  const showNoboEvents = hasSolicitors;
  const showClaimsAdmin = hasClaimsAdministrators;

  return (
    <PageContainer>
      <ScrollContainer sx={{ pt: 8, pb: 10, px: 10 }}>
        <Text variant="h4" sx={{ mb: 6 }}>
          Dashboard
        </Text>

        {showProxyEvents && <DashboardProxyEventsSummary />}
        {showReports && <DashboardReportsSummary />}
        {showNoboEvents && <DashboardNoboEventsSummary />}
        {showClaimsAdmin && <DashboardClaimsAdminSummary />}

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
            gap: 6,
          }}
        >
          <RecentActivitySection />
          <UpcomingDeadlinesSection />
        </Box>
      </ScrollContainer>
    </PageContainer>
  );
}
